import React from "react";
import { Navigate } from "react-router-dom";

const CustomerPrivateRoute = ({ children }) => {
  const customerToken = localStorage.getItem("customerToken");

  if (!customerToken) {
    return <Navigate to="/admin/customerlogin" replace />;
  }

  return children;
};

export default CustomerPrivateRoute;